import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async'
import Select from 'react-select'
import axios from 'axios'
import _ from 'lodash'
import { fixDateString, getDay, getMonth } from '../../helpers/formatDate'
import { replaceAccentedCharacters } from '../../helpers/utils'
import TaskDescription from './components/TaskDescription'
import TaskClientOrAttribute from './components/TaskClientOrAttribute'
import { useTaskAttributeQualifiers } from './components/TaskAttributeHelper'
import TaskScheduleConfig from './components/TaskScheduleConfig'
import {
  getTaskSchedulePayloadForCollect,
  isTaskFormSubmittable
} from './utils/posTaskSchedule'
import {
  getValidPackages,
  getPackageDisplayValue,
  getPackageColumns,
  getAvailablePackages
} from './components/packageHelper'
import { TextField, MenuItem, Box, Typography } from '@mui/material'
let countsCache = {
  brand: {},
  category: {}
}

const InventoryCaptureTask = ({
  setCloningTask,
  cloningTask,
  setFailedCreation,
  failedCreation,
  taskData,
  readyToCollect,
  setReadyToCollect,
  setSaving,
  formDataCollector,
  isStep3Completed,
  setIsStep3Completed
}) => {
  const [description, setDescription] = useState('')
  const [clientOrAttribute, setClientOrAttribute] = useState('')
  const [clients, setClients] = useState([])
  const [products, setProducts] = useState([])
  const [brand, setBrand] = useState('')
  const [category, setCategory] = useState('')
  const [productSelection, setProductSelection] = useState('')
  const {
    qualifiers,
    setQualifiers,
    selectedQualifiers,
    qualifierOptions,
    handleChangeQualifier,
    resetSelectedQualifiers,
    isSomeQualifierSelected,
    validateAtLeastOneQualifier,
    getCollectDataQualifierFields,
    applyClonedTaskQualifiers
  } = useTaskAttributeQualifiers()
  const [users, setUsers] = useState([])
  const [userOptions, setUserOptions] = useState(null)
  const [userFilterChecked, setUserFilterChecked] = useState(false)
  const [isMandatoryTask, setIsMandatoryTask] = useState(false)
  const [productsBase, setProductsBase] = useState({})
  const [productCount, setProductCount] = useState('...')
  const [unitOfSale, setUnitOfSale] = useState('')
  const [unitOfSale1Count, setUnitOfSale1Count] = useState(0)
  const [unitOfSale2Count, setUnitOfSale2Count] = useState(0)
  const [newStartTime, setNewStartTime] = useState(null)
  const [newEndTime, setNewEndTime] = useState(null)
  const [schedulePayload, setSchedulePayload] = useState(null)
  const [showMandatoryConflict, setShowMandatoryConflict] = useState(false)

  const productSelectionType = [
    { value: '', text: 'Escoja una opción', hidden: true },
    { value: 'brand', text: 'Marca' },
    { value: 'category', text: 'Categoría' },
    { value: 'individual_products', text: 'Producto individual' }
  ]

  const packageColumns = getPackageColumns(products)
  const availablePackagesForProducts = getAvailablePackages(products)
  const availablePackages =
    products.length > 0
      ? availablePackagesForProducts
      : [
        Number(productCount) === unitOfSale2Count && unitOfSale2Count > 0 ? 2 : null,
        Number(productCount) === unitOfSale1Count && unitOfSale1Count > 0 ? 1 : null
      ].filter(Boolean)
  const isSelectDisabled = availablePackages.length === 0 || Number(productCount) === 0

  const openUrlNewWindow = (url) => {
    window.open(url, '_blank')
  }

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  var abortClientController = new AbortController()
  var abortProductController = new AbortController()
  const abortCurrentFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
    abortProductController.abort('Fetch Aborted by User.')
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  // Stops client fetch when is unfocus
  const abortClientFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
  }
  //

  // Stops products fetch when is unfocus
  const abortProductFetchs = () => {
    abortProductController.abort('Fetch Aborted by User.')
  }
  //

  const handleStartTimeChange = (newStartTime) => {
    setNewStartTime(newStartTime)
  }

  const handleEndTimeChange = (newEndTime) => {
    setNewEndTime(newEndTime)
  }

  const handleMandatoryConflict = () => {
    setIsMandatoryTask(false)
    setShowMandatoryConflict(true)
  }

  const handleDismissMandatoryConflict = () => {
    setShowMandatoryConflict(false)
  }

  useEffect(() => {
    setIsStep3Completed(
      isTaskFormSubmittable({
        startDate: newStartTime,
        schedulePayload,
        isBaseComplete: clients.length > 0 || isSomeQualifierSelected()
      })
    )
  }, [clients, selectedQualifiers, isSomeQualifierSelected, newStartTime, schedulePayload])

  const handleProductSelectionChange = (event) => {
    setProductSelection(event.target.value)
    setProducts([])
    setUnitOfSale('')
    setBrand(null)
    setCategory(null)
  }

  const isAnyKindOfProductSelected = () => {
    if (products?.length > 0 || brand || category) {
      return true
    }
    return false
  }

  const isClientOrSomeQualifierSelected = () => {
    if (clients?.length > 0 || isSomeQualifierSelected()) {
      return true
    }
    return false
  }

  const handleClientOrAttributeChange = (event) => {
    setClientOrAttribute(event.target.value)
    setClients([])
    resetSelectedQualifiers()
    setUserFilterChecked(false)
    setUsers([])
  }

  const handleUnitOfSaleChange = (event) => {
    setUnitOfSale(event.target.value)
  }

  const handleBrandsChange = (event) => {
    if (event?.brand) {
      setBrand(event.brand)
      setUnitOfSale('')
      fetchDataFromServerPackage(event.brand.db_ref, event.brand.name)
    }
  }

  const handleCategoryChange = (event) => {
    if (event?.category) {
      setCategory(event.category)
      setUnitOfSale('')
      fetchDataFromServerPackage('', '', event.category.db_ref, event.category.description)
    }
  }

  const truncatePreviewText = (text) => {
    if (text?.length > 15) {
      return text.substring(0, 15) + '...'
    }
    return text
  }

  const getClient = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortClientController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/clients?q=${inputValue}&active=true`,
        {
          method: 'GET',
          signal: abortClientController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) =>
          data.table.map((cl) => ({
            value: cl.name,
            label: `${cl.name} - ${cl.db_ref}`,
            client: cl
          }))
        )
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error fetching clients:', error)
            return []
          }
        })
    }
  }

  const getQualifiers = () => {
    const url = `${BASE_BACKEND_URL}/promo_qualifiers`

    authFetch(url, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setQualifiers(data.result[0])
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getUsers = () => {
    authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users?non_paginated=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setUserOptions(
          data.table.map((u) => ({
            value: u.full_name,
            label: `${u.full_name} - ${u.uid}`,
            user: u
          }))
        )
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getUserForCloning = async (uid) => {
    return authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users/${uid}?active=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        return {
          value: data.full_name,
          label: `${data.full_name} - ${data.uid}`,
          user: data
        }
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const displayProductCount = (product_count) => {
    if (product_count == '...') {
      return 'Cargando...'
    }
    let brandCountNum = Number(product_count)
    return isNaN(brandCountNum)
      ? '...'
      : `${brandCountNum} - ${brandCountNum > 1 || brandCountNum == 0 ? 'PRODUCTOS ACTIVOS' : 'PRODUCTO ACTIVO'
      }`
  }

  const getProductsCount = async () => {
    let type = ''
    let typeData = null
    if (category) {
      type = 'category'
      typeData = category.db_ref
    }
    if (brand) {
      type = 'brand'
      typeData = brand.db_ref
    }
    if (typeData) {
      if (countsCache[type][typeData]) {
        setProductCount(countsCache[type][typeData])
      } else {
        setProductCount('...')
        try {
          let resp = await authFetch(
            `${BASE_BACKEND_URL}/products?by_${type}=${typeData}&count_only=true`,
            {
              method: 'GET',
              signal: abortController.signal,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              }
            }
          )
          if (resp.status != 200) {
            console.error('Error al obtener el conteo de productos')
            setProductCount(0)
          }

          let data = await resp.json()
          countsCache[type][typeData] = data.result
          setProductCount(data.result)
        } catch (error) {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        }
      }
    } else {
      setProductCount('...')
    }
  }

  const clearProductBrandOrCategory = () => {
    setBrand(null)
    setCategory(null)
  }

  const fetchDataFromServerPackage = (
    byBrand = '',
    brandName = '',
    byCategory = '',
    categoryName = ''
  ) => {
    return new Promise((resolve, reject) => {
      authFetch(
        `${BASE_BACKEND_URL}/products?page=1` +
        `${byBrand ? '&by_brand=' + byBrand : ''}` +
        `${byCategory ? '&by_category=' + byCategory : ''}` +
        '&package_only=true',
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) => {
          setUnitOfSale1Count(data.total_unidad_de_venta1)
          setUnitOfSale2Count(data.total_unidad_de_venta2)
          resolve(data)
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error fetching data:', error)
            reject(error)
          }
        })
    })
  }

  const getProductsBaseData = () => {
    authFetch(`${BASE_BACKEND_URL}/products/promo_necessary_data`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setProductsBase(data)
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getProducts = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortProductController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/products?q=${replaceAccentedCharacters(
          inputValue
        )}&productactive=true`,
        {
          method: 'GET',
          signal: abortProductController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then((data) => {
          const lookup = _.keyBy(products, (p) => p.db_ref)
          return data.table
            .filter((d) => !lookup[d.db_ref])
            .map((p) => ({
              value: p.name,
              label: `${p.name} - ${p.db_ref}`,
              product: p
            }))
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        })
    }
  }

  const handleClientOption = (options) => {
    setClients(options)
  }

  const handleUsersChange = (options) => {
    setUsers(options)
  }

  const handleProductOption = (options) => {
    if (!options?.product) {
      return
    }
    let alreadyExist = products.find((e) => e.id === options.product.id)
    if (alreadyExist) {
      return
    }
    setProducts([...products, options.product])
  }

  const sleep = (ms) =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, ms)
    })

  const getTaskQuantity = () => {
    let taskQuantity = 0
    if (products?.length > 0) {
      taskQuantity = products.length
    }
    if (productCount != '...' && !isNaN(productCount)) {
      taskQuantity = productCount
    }
    return taskQuantity
  }

  const collectData = () => {
    const scheduleResult = getTaskSchedulePayloadForCollect({
      startDate: newStartTime,
      schedulePayload
    })
    if (!scheduleResult.ok) {
      setFailedCreation(scheduleResult.message)
      setReadyToCollect(false)
      setTimeout(() => setFailedCreation(false), 15000)
      return
    }

    const recurrencePayload = scheduleResult.payload
    let jsonData = {
      description: description,
      completion_mode: recurrencePayload.completion_mode,
      recurrence_format: recurrencePayload.recurrence_format,
      recurrence_interval: recurrencePayload.recurrence_interval,
      recurrence_description: recurrencePayload.recurrence_description,
      start_date: fixDateString(newStartTime),
      end_date: fixDateString(newEndTime),
      qualifier_1: clients.map((c) => c.client.db_ref).sort(),
      ...getCollectDataQualifierFields(),
      user_uids: userFilterChecked ? users.map((u) => u.user.uid).sort() : [],
      user_names: userFilterChecked ? users.map((u) => u.label).sort() : [],
      is_mandatory_task: isMandatoryTask,
      products_selection_type: productSelection,
      category_db_ref: category?.db_ref,
      category_name: category?.description,
      brand_db_ref: brand?.db_ref,
      brand_name: brand?.name,
      products_db_ref: products.map((p) => p.db_ref).sort(),
      product_names: products.map((p) => p.db_ref + ' ' + p.name).sort(),
      unit_of_sale: unitOfSale,
      task_quantity: getTaskQuantity()
    }
    formDataCollector(jsonData)
  }

  const setUpTask = async () => {
    if (taskData) {
      try {
        setCloningTask(true)
        setDescription(taskData.description)

        if (taskData.client_names?.length > 0) {
          setClientOrAttribute('client')
          let _clients = []
          for (const clientName of taskData.qualifier_1) {
            let c = await getClient(clientName)
            if (c?.length > 0) {
              _clients.push(c[0])
            }
          }
          setClients(_clients)
        } else {
          setClientOrAttribute('qualifier')
          applyClonedTaskQualifiers(taskData)
        }

        if (taskData.is_mandatory_task) {
          setIsMandatoryTask(true)
        }

        if (taskData.user_uids?.length > 0) {
          let _users = []
          for (const uid of taskData.user_uids) {
            let user = await getUserForCloning(uid)
            if (user) {
              _users.push(user)
            }
          }
          setUsers(_users)
          setUserFilterChecked(true)
        }
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Clientes/Atributos/Usuarios): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Los clientes o atributos o usuarios, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }
      try {
        switch (taskData.products_selection_type) {
          case 'individual_products':
            {
              setProductSelection('individual_products')
              let _products = []
              for (const productDbRef of taskData.products_db_ref) {
                let p = await getProducts(productDbRef)
                if (p?.length > 0) {
                  _products.push(p[0]?.product)
                }
              }
              let cleanProducts = _products.filter(
                (value, index, self) => index === self.findIndex((t) => t.db_ref === value.db_ref)
              )
              setProducts(cleanProducts)

              if (availablePackagesForProducts.includes(Number(taskData.unit_of_sale?.split('_').pop()))) {
                setUnitOfSale(taskData.unit_of_sale)
              }
            }
            break
          case 'brand':
            {
              setProductSelection('brand')
              let _brand = productsBase?.brand?.find((b) => b.db_ref === taskData.brand_db_ref)
              setBrand(_brand)
              fetchDataFromServerPackage(taskData.brand_db_ref, taskData.brand_name)
            }
            break
          case 'category':
            {
              setProductSelection('category')
              let _category = productsBase?.categories?.find(
                (c) => c.db_ref === taskData.category_db_ref
              )
              setCategory(_category)
              fetchDataFromServerPackage(
                '',
                '',
                taskData.category_db_ref,
                taskData.category_name
              )
            }
            break
        }
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Productos/Marcas/Categorias): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Productos/Marcas/Categorias, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }
      setCloningTask(false)
      await sleep(1000)
      setSaving(false)
    }
  }

  useEffect(() => {
    getQualifiers()
    getUsers()
    getProductsBaseData()
  }, [])

  useEffect(() => {
    if (taskData) {
      setUpTask()
    }
  }, [taskData, productsBase.brand, productsBase.categories])

  useEffect(() => {
    getProductsCount()
  }, [category, brand])

  useEffect(() => {
    if (
      taskData?.unit_of_sale &&
      availablePackages.includes(Number(taskData.unit_of_sale.split('_').pop()))
    ) {
      setUnitOfSale(taskData.unit_of_sale)
    }
  }, [taskData?.unit_of_sale, availablePackages.join(',')])

  useEffect(() => {
    if (readyToCollect) {
      collectData()
    }
  }, [readyToCollect])

  const isStep5Enabled = products.length > 0 || brand || category

  if (cloningTask) {
    return null
  }
  return (
    <>
      <TaskDescription initialDescription={description} onDescriptionChange={setDescription} />

      <TaskClientOrAttribute
        clientOrAttribute={clientOrAttribute}
        handleClientOrAttributeChange={handleClientOrAttributeChange}
        clients={clients}
        handleClientOption={handleClientOption}
        getClient={getClient}
        abortClientFetchs={abortClientFetchs}
        selectedQualifiers={selectedQualifiers}
        qualifierOptions={qualifierOptions}
        onQualifierChange={handleChangeQualifier}
        validateAtLeastOneQualifier={() => validateAtLeastOneQualifier(selectedQualifiers)}
        description={description}
        isClientOrSomeQualifierSelected={isClientOrSomeQualifierSelected}
        isMandatoryTask={isMandatoryTask}
        setIsMandatoryTask={setIsMandatoryTask}
        recurrenceType={schedulePayload?.completion_mode}
        onMandatoryBlocked={handleMandatoryConflict}
        showMandatoryConflict={showMandatoryConflict}
        onDismissMandatoryConflict={handleDismissMandatoryConflict}
        userFilterChecked={userFilterChecked}
        setUserFilterChecked={setUserFilterChecked}
        users={users}
        userOptions={userOptions}
        handleUsersChange={handleUsersChange}
      />
      <div className="task-form-section">
        <div className="title-promos-form">
          <b class="bold-step">PASO 4: Escoja los productos que aplican a esta tarea</b>
        </div>
        <hr className="hr-task-form" />
        <p>Por marca, categoría o productos individuales</p>
        <div className="task-form-control-width ">
          <TextField
            select
            fullWidth
            size="small"
            label="Tipo de selección"
            value={productSelection}
            onChange={(e) => {
              if (!isClientOrSomeQualifierSelected()) return
              handleProductSelectionChange(e)
            }}
            required
            sx={{
              pointerEvents: !isClientOrSomeQualifierSelected() ? 'none' : 'auto',
              opacity: !isClientOrSomeQualifierSelected() ? 0.6 : 1,
              backgroundColor: !isClientOrSomeQualifierSelected() ? '#f0f0f0' : 'transparent',
              '& .MuiInputBase-input': {
                cursor: !isClientOrSomeQualifierSelected() ? 'not-allowed' : 'pointer'
              }
            }}
          >
            {productSelectionType?.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                sx={{ display: option.hidden ? 'none' : 'block' }}
              >
                {option.text}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>

      {productSelection === 'individual_products' && (
        <div className="task-form-section">
          <div className="title-promos-form">
            <p>
              <b>PASO 4.1: Escoja los productos que aplican a esta tarea</b>
            </p>
          </div>
          <div className="task-form-control-width">
            <div className="fake-validator-container">
              <input
                className="input-fake-validator"
                type="text"
                required
                value={products.length >= 1 ? products : null}
              />
              <AsyncSelect
                className="clients"
                placeholder={'Escribir nombre o código del producto'}
                noOptionsMessage={() => 'No hay resultados'}
                loadingMessage={() => 'Cargando productos...'}
                name="selectOptionProducts"
                loadOptions={getProducts}
                isClearable={true}
                searchParamName={'q'}
                isSearchable={true}
                value={[]}
                onChange={(e, am) => {
                  handleProductOption(e)
                  am.action = 'clear'
                }}
                onBlur={abortProductFetchs}
              />
            </div>
          </div>
          {products?.length > 0 && (
            <div className="row">
              <table className="table-pdv table-hover task-product-table">
                <thead className="table-header-gray-task">
                  <tr>
                    <th className="pl-20">CÓDIGO</th>
                    <th>NOMBRE DEL PRODUCTO</th>
                    {packageColumns.map((column) => (
                      <th key={column.label}>{column.label}</th>
                    ))}
                    <th className="centered">ACCIÓN</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.map((product, index) => (
                    <tr key={`${product.id}-${index}`}>
                      <td className="pl-20">{product.db_ref}</td>
                      <td>{product.name}</td>
                      {packageColumns.map((column) => {
                        const productPackages = getValidPackages(product)

                        return <td key={`${product.id}-${column.label}`}>{getPackageDisplayValue(productPackages[column.index])}</td>
                      })}
                      <td
                        className="delete-selected-product"
                        onClick={(e) => setProducts(products.filter((p) => p.id !== product.id))}
                      >
                        &times;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {productSelection === 'brand' && (
        <div className="task-form-section">
          <div className="title-promos-form">
            <p>
              <b>PASO 4.1: Seleccione la marca de los productos para esta tarea</b>
            </p>
          </div>
          <div className="task-form-control-width">
            <div className="fake-validator-container">
              <input
                className="input-fake-validator"
                type="text"
                required
                value={brand?.db_ref ? brand?.db_ref : null}
              />
              <Select
                isDisabled={brand ? true : false}
                placeholder={'Escoja una opcion'}
                noOptionsMessage={() => 'No hay resultados'}
                loadingMessage={() => 'Cargando...'}
                className="qualifier"
                isClearable={false}
                value={brand ? { value: brand.db_ref, label: brand.name } : null}
                onChange={(e) => handleBrandsChange(e)}
                options={productsBase?.brand?.map((option) => {
                  return { value: option.db_ref, label: option.name, brand: option }
                })}
              />
            </div>
          </div>
          {isAnyKindOfProductSelected() && (
            <div className="box-products-preview-container-pos mt-20">
              <div className="box-products-preview-pos mr-10">
                <p className="m-0" title={brand?.name}>
                  {displayProductCount(productCount)}
                </p>
                <div onClick={clearProductBrandOrCategory} className="delete-selected-product">
                  &times;
                </div>
              </div>
              <button
                type="button"
                onClick={() =>
                  openUrlNewWindow(`/productos?by_brand=${brand.db_ref}&brand_name=${brand.name}`)
                }
                className="big-btn-tasks"
              >
                Ver lista de productos
              </button>
            </div>
          )}
        </div>
      )}
      {productSelection === 'category' && (
        <div className="task-form-section">
          <div className="title-promos-form">
            <p>
              <b>PASO 4.1: Seleccione la categoría de los productos para esta tarea</b>
            </p>
          </div>
          <div className="task-form-control-width">
            <div className="fake-validator-container">
              <input
                className="input-fake-validator"
                type="text"
                required
                value={category?.db_ref ? category?.db_ref : null}
              />
              <Select
                isDisabled={category ? true : false}
                placeholder={'Escoja una opcion'}
                noOptionsMessage={() => 'No hay resultados'}
                loadingMessage={() => 'Cargando...'}
                className="qualifier"
                isClearable={true}
                value={category ? { value: category.db_ref, label: category.description } : null}
                onChange={(e) => handleCategoryChange(e)}
                options={productsBase?.categories?.map((option) => {
                  return { value: option.db_ref, label: option.description, category: option }
                })}
              />
            </div>
          </div>
          {isAnyKindOfProductSelected() && (
            <div className="box-products-preview-container-pos mt-20">
              <div className="box-products-preview-pos mr-10">
                <p className="m-0" title={category?.description}>
                  {displayProductCount(productCount)}
                </p>
                <div onClick={clearProductBrandOrCategory} className="delete-selected-product">
                  &times;
                </div>
              </div>
              <button
                type="button"
                onClick={() =>
                  openUrlNewWindow(
                    `/productos?by_category=${category.db_ref}&category_name=${category.description}`
                  )
                }
                className="big-btn-tasks"
              >
                Ver listado de productos
              </button>
            </div>
          )}
        </div>
      )}
      {isAnyKindOfProductSelected() && (
        <>
          <p className="title-task-form">
            <b>PASO 4.2: Seleccione la unidad de venta de los productos a aplicar en la tarea</b>
          </p>
          <div className="task-form-control-width">
            <TextField
              select
              fullWidth
              size="small"
              label="Unidad de venta"
              value={unitOfSale || ''}
              onChange={handleUnitOfSaleChange}
              required
              sx={{
                pointerEvents: isSelectDisabled ? 'none' : 'auto',
                opacity: isSelectDisabled ? 0.6 : 1,
                backgroundColor: isSelectDisabled ? '#f0f0f0' : 'transparent',
                '& .MuiInputBase-input': {
                  cursor: isSelectDisabled ? 'not-allowed' : 'pointer'
                }
              }}
            >
              <MenuItem value="">
                Escoja una opción
              </MenuItem>

              {availablePackages.map((unitNumber) => (
                <MenuItem key={unitNumber} value={`unit_of_sale_${unitNumber}`}>
                  {`Unidad de venta ${unitNumber}`}
                </MenuItem>
              ))}
            </TextField>
            {Number(productCount) == 0 && (
              <p className="warning-text">
                {productSelection === 'brand' &&
                  'La marca seleccionada no tiene productos disponibles. Elige una marca diferente para continuar.'}
                {productSelection === 'category' &&
                  'La categoría seleccionada no tiene productos disponibles. Elige una categoría diferente para continuar.'}
              </p>
            )}
            {isSelectDisabled && Number(productCount) !== 0 && (
              <p className="warning-text">
                Los productos seleccionados carecen de paquetes necesarios. Ver lista de productos.
              </p>
            )}
          </div>
        </>
      )}

      <div className="task-form-section">
        <TaskScheduleConfig
          isEnabled={isStep5Enabled}
          onScheduleChange={setSchedulePayload}
          onStartChange={handleStartTimeChange}
          onEndChange={handleEndTimeChange}
          isMandatoryTask={isMandatoryTask}
          onMandatoryConflict={handleMandatoryConflict}
          showMandatoryConflict={showMandatoryConflict}
          onDismissMandatoryConflict={handleDismissMandatoryConflict}
        />
      </div>
    </>

  )
}
export default InventoryCaptureTask
